import axios from "axios"
export function toggleAdvertisment(token, advertiserId, newStatus) {
    return axios.get(process.env.REACT_APP_API_URL + `/toggleAdvertisementActive?advertisementId=${advertiserId}&advertisementNewStatus=${newStatus}`, {
        headers: {
            'Authorization': `${token}`
        }
    });
}